import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Imgcomponent, { LOADING_IMG } from '../../HOCs/ImageHocs';
import * as hooks from './hooks';
import WithErrorBoundary from '../../HOCs/WithErrorBoundary';
import { getContentImageByMode } from '../../utils/imageUtils';
import { formattedFlightsUntil } from '../../utils/dateFnsUtils';
import { CONTENT_PROPS, IMAGE_CROP_MODES } from '../shared/constants';
import FadeIn from 'react-fade-in/lib/FadeIn';

//#region ////// COMPONENTS //////flightsFormattedUntil
//#endregion

import './styles.scss';
import { IMAGE_MODE } from '../../constants/imageMode';
import ContentOverviewSkeleton from './components/ContentOverviewSkeleton';
import ContentCard from '../ContentCard';
import { FILTER_NAME, TEXT_MODE } from '../../constants/textMode';
import classNames from '../../utils/classnameUtils';
import { CONTENT_TYPES } from '../../constants/contentTypes';
import TooltipRating from './components/TooltipRating';
import RatingContainer from './components/RatingContainer';

function ContentOverview({
  addButtonTitle,
  content,
  ratingsList,
  disabledPlayButton = false,
  ctaButtonTitle,
  customAddButtonIcon = null,
  customCTAButtonIcon = null,
  hideButtons = false,
  hideButtonIcons = false,
  found_poster = false,
  found_thumb = false,
  thumb = '',
  onClickAddButtonHandler,
  onClickCTAButtonHandler,
  onClickPlayerButton,
  onClickMyListButton,
  onClickBackButton,
  translationTexts,
  contentNoImageProps,
  isLoading,
  currentContentPosition,
  inFavoritesAdded,
  favoritesIsFetching,
  handleSearchContentByFilter,
  redirectContent = false,
  showAvailableUntilDescription = false,
  ratingImages,
  mustShowRatingImage = false,
  showPlayIcon = true,
  imageMode = IMAGE_MODE.POSTER,
  children,
  showRating = true,
  showChannel = true,
  showYear = true,
  showDuration = true,
  hasAccessTo = true,
  hasAccessToIcon = 'bi bi-credit-card'
}) {
  //if(isLoading) return ContentOverviewSkeleton(contentNoImageProps)

  const {
    id: contentId,
    title,
    release,
    duration,
    genres,
    description,
    ratings,
    contentType,
    arrayDirector,
    arayCast,
    arrayFlightsStartEnd,
    endFlight,
  } = hooks.useContent(content);
  const {
    play_in,
    play_now,
    available_in,
    available_until,
    director: director_text,
    cast: cast_text,
    genders,
    my_list,
    continue_watching,
    add_favorites,
    remove_favorites,
    content_classification,
    buy_subscription
  } = translationTexts ?? {};
  const { currentContent, bookmark, bookmarkEpisodes } =
    currentContentPosition ?? {};
  const { entitlementTypes } = currentContent ?? {};
  const thumbBackground =
    !isLoading && getContentImageByMode(content?.images, 'THUMB')?.url;

  const labelFunction = (arrayR, filterName) => {
    let result = arrayR?.map((e) => {
      return (
        <span key={e} className="contentOverviewLabel">
          <a onClick={() => handleSearchContentByFilter(e, filterName)}>{e}</a>
        </span>
      );
    });
    return result;
  };

  const timeHr = (s) => {
    return Math.floor(s / 3600);
  };

  const timeMin = (s) => {
    return Math.floor((s / 60) % 60);
  };

  const contentIdFunction = () => {
    let contentId;
    if (contentType === 'SERIE') {
      //contentId = content.episodesBySeason[0]?.episodes[0];
      contentId =
        currentContentPosition?.contentEpisodes?.episodes[0]?.id ||
        content.episodesBySeason[0]?.episodes[0];
    }
    if (contentType === 'MOVIE') {
      contentId = content.id;
    }
    return contentId;
  };

  const checkRedirect = (entitlementTypes) => {
    return !!entitlementTypes?.some((e) => e === 'redirect');
  };

  const contentNoImagePropsR = {
    ...contentNoImageProps,
    backgroundColorOne: contentNoImageProps?.backgroundColorTwo,
    backgroundColorTwo: contentNoImageProps?.backgroundColorOne,
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {inFavoritesAdded ? remove_favorites : add_favorites}
    </Tooltip>
  );

  return (
    <React.Fragment>
      <div className="contentOverviewContainer">
        <figure className="contentOverviewBackground">
          {!isLoading && (
            <Imgcomponent
              src={thumbBackground}
              crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
              size={IMAGE_MODE.THUMB_OVERVIEW}
              loading={LOADING_IMG.EAGER}
            />
          )}
        </figure>
        <div className="contentOverviewWrapper">
          <div className="contentOverviewHedear">
            <FadeIn>
              <Button
                className="contentOverviewExitButtom"
                onClick={onClickBackButton}
              >
                <i className="bi bi-arrow-left-short"></i>
              </Button>
            </FadeIn>
          </div>

          <div className="contentOverviewDetail">
            <FadeIn>
              <ContentCard
                className={imageMode === IMAGE_MODE.POSTER ? "contentOverviewPoster" : ""}
                content={content}
                imageMode={imageMode}
                textMode={TEXT_MODE.NONE}
                isLoading={isLoading}
                contentNoImageProps={contentNoImagePropsR}
                loading={LOADING_IMG.EAGER}
                translationTexts={translationTexts}
              />
            </FadeIn>
            <div className="contentOverviewInfo">
              {isLoading ? (
                <FadeIn>
                  <ContentOverviewSkeleton
                    backgroundColor={contentNoImagePropsR.backgroundColorOne}
                    foregroundColor={contentNoImagePropsR.backgroundColorTwo}
                    speed={2}
                  />
                </FadeIn>
              ) : (
                <FadeIn>
                  <div className="contentOverviewTitle">
                    <h2>{title}</h2>
                  </div>

                  {(showChannel || showDuration || showRating || showYear) && (
                    <div className="contentOverviewPeriod">
                      <div className="contentOverviewCategory">
                        { showRating && <>
                          {!!ratings && ratingsList ? (
                          <TooltipRating
                            ratings={ratings}
                            ratingsList={ratingsList}
                            title={content_classification}
                          />
                          ) : (
                            <RatingContainer
                              ratings={ratings}
                              ratingImages={ratingImages}
                              mustShowRatingImage={mustShowRatingImage}
                            />
                          )}
                        </>}

                        {showYear && !!release && (
                          <p className="contentOverviewYear">{release}</p>
                        )}

                        {showDuration && !!duration && (
                          <div className="contentOverviewLenght">
                            {!!timeHr(duration) && (
                              <p className="contentOverviewHr">
                                <span className="contentOverviewHrNumber">
                                  {timeHr(duration)}
                                </span>
                                <span className="contentOverviewHrText">
                                  hs
                                </span>
                              </p>
                            )}
                            {!!timeMin(duration) && (
                              <p className="contentOverviewMin">
                                <span className="contentOverviewMinNumber">
                                  {timeMin(duration)}
                                </span>
                                <span className="contentOverviewMinText">
                                  min
                                </span>
                              </p>
                            )}
                          </div>
                        )}
                      </div>

                      {showChannel && !!content.networks && (
                        <p className="contentOverviewNetworkBadge">
                          {!!available_in && (
                            <span>{`${available_in}: `} </span>
                          )}
                          <span>
                            {content.networks
                              ?.map((network) => network.name)
                              .join(', ')}
                          </span>
                        </p>
                      )}

                      {showAvailableUntilDescription && endFlight && (
                        <p className="contentOverviewAvailableBadge">
                          <span className="contentOverviewAvailableBadgeText">{`${available_until}:`}</span>
                          <span>
                            {formattedFlightsUntil(arrayFlightsStartEnd)}
                          </span>
                        </p>
                      )}
                    </div>
                  )}

                  {React.isValidElement(children) && (
                    <div className="contentOverviewFutureOptions">
                      {children}
                    </div>
                  )}

                  <div className="contentOverviewActions">
                    {typeof onClickPlayerButton === 'function' && (
                      <div className="contentOverviewActionsContainerPlay">
                        <Button
                          variant=""
                          className={classNames(
                            'contentOverviewActionsPlay',
                            'contentOverviewActionsPlay_disabled_' +
                              disabledPlayButton,
                            !showPlayIcon ? 'no-icon' : ''
                          )}
                          onClick={() =>
                            !disabledPlayButton &&
                            onClickPlayerButton(contentIdFunction())
                          }
                        >
                          {redirectContent ? (
                            <React.Fragment>
                              <span className="contentOverviewActionsPlayTitle">{`${play_in}: ${content.networks
                                ?.map((network) => network.name)
                                .join(', ')}`}</span>
                            </React.Fragment>
                          ) : !hasAccessTo ?
                          
                          (
                            <React.Fragment>
                              <i className={hasAccessToIcon}></i>
                              <span className="contentOverviewActionsBuyTitle">
                                {buy_subscription}
                              </span>
                            </React.Fragment>
                          )
                          
                          : !redirectContent &&
                            ((contentType === CONTENT_TYPES.SERIE &&
                              bookmarkEpisodes?.length > 0) ||
                              (contentType !== CONTENT_TYPES.SERIE &&
                                bookmark?.position > 0)) ? (
                            <React.Fragment>
                              {showPlayIcon && (
                                <i className="bi bi-play-fill"></i>
                              )}
                              <span className="contentOverviewActionsPlayTitle">
                                {continue_watching}
                              </span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              {showPlayIcon && (
                                <i className="bi bi-play-fill"></i>
                              )}
                              <span className="contentOverviewActionsPlayTitle">
                                {play_now}
                              </span>
                            </React.Fragment>
                          )}
                        </Button>
                      </div>
                    )}
                    {typeof onClickMyListButton === 'function' && (
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <Button
                          variant=""
                          className="contentOverviewActionsMyList"
                          onClick={() =>
                            onClickMyListButton(contentId, inFavoritesAdded)
                          }
                        >
                          {inFavoritesAdded ? (
                            <i className="bi bi-check"></i>
                          ) : (
                            <i className="bi bi-plus"></i>
                          )}
                          <span className="contentOverviewActionsMyListTitle">
                            {my_list}
                          </span>
                        </Button>
                      </OverlayTrigger>
                    )}
                  </div>
                  {typeof description === 'string' &&
                    description.length > 0 && (
                      <div className="contentOverviewDescription">
                        <p className="contentOverviewDescriptionText">
                          {description}
                        </p>
                      </div>
                    )}
                  <div className="contentOverviewCast">
                    {Array.isArray(genres) && genres.length > 0 && (
                      <p className="contentOverviewGenre">
                        <span className="contentOverviewGenreTitle">{`${genders}:`}</span>
                        <span>{labelFunction(genres, FILTER_NAME.GENRES)}</span>
                      </p>
                    )}
                    {Array.isArray(arrayDirector) &&
                      arrayDirector.length > 0 && (
                        <p className="contentOverviewDirector">
                          <span className="contentOverviewDirectorTitle">
                            {director_text}:
                          </span>
                          <span>
                            {labelFunction(
                              arrayDirector,
                              FILTER_NAME.PARTICIPANT
                            )}
                          </span>
                        </p>
                      )}
                    {Array.isArray(arayCast) && arayCast.length > 0 && (
                      <p className="contentOverviewActors">
                        <span className="contentOverviewActorsTitle">
                          {cast_text}:
                        </span>
                        <span>
                          {labelFunction(arayCast, FILTER_NAME.PARTICIPANT)}
                        </span>
                      </p>
                    )}
                  </div>
                  <div className="contentOverviewSocial">
                    <a href={{}}>
                      <i className="bi bi-facebook"></i>
                    </a>
                    <a href={{}}>
                      <i className="bi bi-twitter"></i>
                    </a>
                  </div>
                </FadeIn>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

ContentOverview.propTypes = {
  addButtonTitle: PropTypes.string,
  content: PropTypes.shape(CONTENT_PROPS),
  disabledPlayButton: PropTypes.bool,
  ctaButtonTitle: PropTypes.string,
  customAddButtonIcon: PropTypes.func,
  customCTAButtonIcon: PropTypes.func,
  hideButtons: PropTypes.bool,
  hideButtonIcons: PropTypes.bool,
  onClickAddButtonHandler: PropTypes.func,
  onClickPlayerButton: PropTypes.func,
  onClickBackButton: PropTypes.func,
  contentNoImageProps: PropTypes.object,
  isLoading: PropTypes.bool,
  currentContentPosition: PropTypes.object,
  inFavoritesAdded: PropTypes.bool,
  favoritesIsFetching: PropTypes.bool,
  handleSearchContentByFilter: PropTypes.func,
  redirectContent: PropTypes.bool,
  showAvailableUntilDescription: PropTypes.bool,
  ratingImages: PropTypes.array,
  mustShowRatingImage: PropTypes.bool,
  showPlayIcon: PropTypes.bool,
  hasAccessTo: PropTypes.bool,
  hasAccessToIcon: PropTypes.string
};

export default WithErrorBoundary(React.memo(ContentOverview));
